import { IBaseEntityResource, IShowEndpoint } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";

export const useDetailsPageEntityLoader = <TUpdateResource extends IBaseEntityResource>(
	service: IShowEndpoint<TUpdateResource>,
) => {
	const { id = "" } = useParams<"id">();
	const { data, isLoading } = useQuery({
		queryKey: service.showKey(id),
		queryFn: () =>
			service.show(id).then((x) => {
				return x.data.data;
			}),
	});

	return { data, isLoading, id };
};
